// extracted by mini-css-extract-plugin
module.exports = {"container":"main_container__3e7bG","intervals":"main_intervals__n_J1R"};